document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[type="search"][name="q"]');
      let query = input?.value.trim();

      if (!query) return;

      if (/^\d+$/.test(query)) {
        query = `"${query}"`;
      }

      e.preventDefault();

      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    });
  });
});
